// extracted by mini-css-extract-plugin
export var container = "_dh-0";
export var infoIcon = "_dh-2";
export var internalLabel = "_dh-3";
export var titleRowCol = "_dh-1";